import { FC } from 'react';

export const FooterContent: FC = ({ children }) => {
  return <>{children}</>;
};
